
// Definición de defaults

export const defaultDemandaInicial: DemandaInicialProps = {
    idDemandaInicial: 0,
    cuantia: '',
    idTipoJuicio: 0,
    tipoJuicio: '',
    folioBuzonElectronico: '',
    escritoBuzonElectronico: '',
    acuseBuzonElectronico: '',
    digitalizacion: '',
    idEstatus: 0,
    estatus: '',
    partes: [],
    actores: [],
    demandados: [],
    prestaciones: [],
    anexosBuzonElectronico: [],
}

// Creación de interfaces

export interface DemandaInicialProps {
    idDemandaInicial:        number;
    cuantia:                 string;
    idTipoJuicio:            number;
    tipoJuicio:              string;
    folioBuzonElectronico:   string;
    escritoBuzonElectronico: string;
    acuseBuzonElectronico:   string;
    digitalizacion:          string;
    idEstatus:               number;
    estatus:                 string;
    actores:                 string[];
    demandados:              string[];
    prestaciones:            string[];
    partes:                  string[];
    anexosBuzonElectronico:  AnexosBuzonElectronicoProps[];
}

export interface AnexosBuzonElectronicoProps {
    archivo:        string;          
    descripcion:    string;                  
    url:            string;              
}